import { Timestamp } from 'firebase/firestore';

/**
 * ユーザーの権限
 * - admin: アカウント管理・事業者管理を操作できる
 * - user: 一般ユーザー
 */
export type UserRole = 'admin' | 'user';

/** 権限の表示ラベル */
export const ROLE_LABELS: Record<UserRole, string> = {
  admin: '管理者',
  user: '一般ユーザー',
};

/**
 * ユーザー（ログインアカウント）情報の型定義
 * 事業者名・犬舎名は settings/business（BusinessInfo）で管理する
 */
export interface User {
  uid: string;
  email: string;
  userName: string; // ユーザー名（Auth displayName にも同値を設定）
  role?: UserRole; // 未設定は 'user' 扱い。付与はアカウント管理画面（管理者のみ）から
  createdAt: Timestamp;
  lastLoginAt: Timestamp;
}

/**
 * ユーザー登録フォームの型定義
 */
export interface UserRegistrationData {
  email: string;
  password: string;
  userName: string;
}

/**
 * ログインフォームの型定義
 */
export interface LoginData {
  email: string;
  password: string;
}
